import React, { useState } from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { ProblemReveal } from '../components/ProblemReveal';
import { SolutionSection } from '../components/SolutionSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { CTASection } from '../components/CTASection';
import { FloatingCTA } from '../components/FloatingCTA';
import { LanguageProvider, useLanguage } from '../hooks/useLanguage';
import { LanguageToggle } from '../components/LanguageToggle';
import { TermsModal } from '../components/TermsModal';
function SalesPageContent() {
  const {
    t
  } = useLanguage();
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  return <div className="min-h-screen bg-background text-foreground overflow-x-hidden selection:bg-[#D4A843] selection:text-black" data-id="element-204">
      <LanguageToggle data-id="element-205" />
      <main data-id="element-206">
        <HeroSection data-id="element-207" />
        <PainSection data-id="element-208" />
        <ProblemReveal data-id="element-209" />
        <SolutionSection data-id="element-210" />
        <BenefitsSection data-id="element-211" />
        <CTASection data-id="element-212" />
      </main>

      <footer className="py-8 text-center text-gray-600 text-sm border-t border-white/5 bg-[#050508]" data-id="element-213">
        <p data-id="element-214">
          © {new Date().getFullYear()} {t('footer_copyright')}
        </p>
        <div className="mt-2 space-x-4" data-id="element-215">
          <button onClick={() => setIsTermsOpen(true)} className="hover:text-gray-400 transition-colors" data-id="element-216">
            {t('footer_terms')}
          </button>
          <a href="#" className="hover:text-gray-400" data-id="element-217">
            {t('footer_privacy')}
          </a>
        </div>
      </footer>

      <FloatingCTA data-id="element-218" />
      <TermsModal isOpen={isTermsOpen} onClose={() => setIsTermsOpen(false)} data-id="element-219" />
    </div>;
}
export function SalesPage() {
  return <LanguageProvider data-id="element-220">
      <SalesPageContent data-id="element-221" />
    </LanguageProvider>;
}